import type { CSSProperties, ReactNode } from 'react';

import Colors from '../../styles/Colors';

export interface PageContentProps {
  isBlue?: boolean;
  hasPadding?: boolean;
  children?: ReactNode;
  sx?: CSSProperties;
}

export const PageContent = ({
  isBlue = false,
  hasPadding: _hasPadding = true,
  children = null,
  sx,
}: PageContentProps) => {
  const base: CSSProperties = isBlue
    ? { backgroundColor: Colors.pageContentBlue, minHeight: '100vh' }
    : { backgroundColor: 'var(--chakra-colors-bg)' };
  return <div style={{ ...base, ...sx }}>{children}</div>;
};
